import request, { type CustomAxiosRequestConfig } from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { OperationHistory, OperationHistoryParams } from "@/entity/logistics/operationHistory";

export class OperationHistoryService extends BaseService<OperationHistory, unknown, OperationHistoryParams, unknown> {
    public async getDetail(params: OperationHistoryParams): Promise<OperationHistory[]> {
        // 操作日志是详情页的辅助信息，失败时不能覆盖主页面或 Tab 的视觉状态。
        const { data } = await this.service.get(`${this.path}/findByModule`, {
            params,
            loading: false,
            suppressGlobalError: true
        } as CustomAxiosRequestConfig);
        return data;
    }
}

export const operationHistoryService = new OperationHistoryService("/admin/operationHistory", request.service);
